import { render } from "./Empty.vue?vue&type=template&id=51cec68e"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__